import React from 'react';
import { useEffect, useMemo, useRef, useState } from 'react';

import {Photos} from './photos';
import { ExportChartData } from './export.js';

import { Tabs, Row, Col, Space, Button, Dropdown, Select, Menu, Switch, Flex } from 'antd';
import { CustomDatepicker } from '../datepicker/custom.datepicker.js';
import { FileExcelOutlined, ReloadOutlined, DownOutlined, CopyOutlined, InfoCircleOutlined, QuestionCircleOutlined, ZoomOutOutlined } from '@ant-design/icons';

import Draggable from 'react-draggable';
import { Resizable } from 'react-resizable';
import '../../../node_modules/react-resizable/css/styles.css';

import dayjs from 'dayjs';

import References from '../../helpers/Reference';
import {
    loadMeasurers,
    loadPhotos,
    parsePhotos,
    getChartType,
    findInJSONArray,
    objectValue,
    objectKey,
    CopyText,
    ShowLocaleDateTime,
    prepareMeasurers,
    loadGroupMeasurers,
    prepareGroupMeasurers,
    findIndexInJSONArray,
    hasNestedProperty,
    getNestedProperty,
    getDangerShortName,
    formatMchExtInfo
} from '../../helpers/helpers';
import {AnalyticChartChange} from './components/analytic.radio-groups.js';

import Chart from "chart.js/auto";
import { Line, Bar, PolarArea } from 'react-chartjs-2';
import annotationPlugin from 'chartjs-plugin-annotation';
import zoomPlugin from 'chartjs-plugin-zoom';
import { CategoryScale } from "chart.js";

import 'chartjs-adapter-moment';
import { chartBarOptions, chartPolarOptions } from '../../helpers/chartoptions';
import { forecastPics, polarChartPrepareData, round } from '../../helpers/helpers';

import { Events } from '../Event/events.component.js';
import { Analytic } from './analytic.js';

import { useAuth } from '../Auth/store.js';
import { normalizedOptions, waterlevelBasisOptions, resolveMchForChart, CorrrectGroupToMch, FindFirstMchInGroup, getChartDatasets, GetFirstValueOfBasis, getGroupChartData, getMeasurerLastTime, GetMeasurerLastValueByBasis, GetMeasurerUnitByBasis, normalizeChartRange, setChartMax, setChartMin, setLineChartOptions, SetMchGroups, showForecastTitle, ShowMeasurerLastTime } from './utils.js';
import { ChartTabs } from './ChartTabs.js';
import { MchsDropdown } from './mchs.dropdown.js';
import { ChartWindowHelpContext } from './components/help-context.js';
import { AnalyticHelpContext } from './components/help-context-analytic.js';
import { EventHelpContext } from './components/help-context-events.js';
import { WindroseHelpContext } from './components/help-context-windrose.js';
import { ForecastAggHelpContext } from './components/help-context-forecast-agg.js';
import { PhotoGallery } from '../PhotoGallery/photo.gallery.js';
import { WaterlevelHelpContext } from './components/help-context.waterlevel.js';
import { ChartForecastWaterlevel, ForecastWaterlevel, forecastwaterlevel } from './chart.forecast.waterlevel.js';
import { ComparisonChannelButton } from '../compasion/ComparisonChannelButton';

dayjs.locale('ru');
Chart.register(CategoryScale);
Chart.register(annotationPlugin);
Chart.register(zoomPlugin);

export const ChartWindow = ({station, mchs, onClose}) => {    
    const type = 'mchs';
    const DRAGGABLE_BOUNDS_PERCENT = 0.15;
    const AUTO_REFRESH_CHART_MS = 5 * 60 * 1000

    const now = station?.finish ? new Date(station.finish) : new Date().getTime() + 1000 * 3600 * 2;
    const prev = station?.start ? new Date(station.start) : now - 1000 * 60 * 60 * 24;
    const prev3days = now - 1000 * 60 * 60 * 24 * 3;
    const stationInfo = station.station;

    const [ loaded, setLoaded ] = useState( false );
    const [ prepared, setPrepared ] = useState( false );
    const [ expired, setExpired ] = useState( false );

    const [ activeTab, setActiveTab ] = useState('mchs');
    const [ measurer, setMeasurer ] = useState({});
    const [ footerMeasurer, setFooterMeasurer ] = useState({});
    const [ measurerBasis, setMeasurerBasis] = useState()
    const [ forecastTab, setForecastTab ] = useState('summary_tab');

    const [ data, setData ] = useState(null)
    const [ chartType, setChartType] = useState( null );
    const [ chartData, setChartData ] = useState({});
    const [ isChartRedraw, setIsChartRedraw ] = useState( false );
    const [ isLineChartZoomed, setIsLineChartZoomed ] = useState(false);
    const [ isBarChartZoomed, setIsBarChartZoomed ] = useState(false);
    const lineChartRef = useRef(null);
    const barChartRef = useRef(null);
    const isResettingLineChartZoom = useRef(false);
    const isResettingBarChartZoom = useRef(false);
    const [ chartSettings, setChartSettings] = useState({});
    const [ chartKind, setChartKind] = useState('chart');
    const [ chartTabActive, setChartTabActive ] = useState(0);

    //настройки для сгрппуированных каналов
    const [ isChartGrouped, setIsChartgrouped ] = useState( false );
    const [ measurerGroups, setMeasurerGroups ] = useState([]);
    const [ measurersHiddenInGroup, setMeasurersHiddenInGroup ] = useState([]);

    //закладка для разных типов графика для одного ИК (ветер: роза ветров и линейный график, две вкладки)
    const [ chartForciblyType, setChartForciblyType] = useState();

    const [ start, setStart ] = useState( new Date(prev).toLocaleString(References.locale) );
    const [ finish, setFinish ] = useState( new Date(now).toLocaleString(References.locale) );
    const [ autoUpdateEnabled, setAutoUpdateEnabled ] = useState(false);

    const [ loadedPhoto, setLoadedPhoto ] = useState( false );
    const [ expiredPhoto, setExpiredPhoto ] = useState( false );
    const [ photos, setPhotos ] = useState([]);
    const [ lastPhoto, setLastPhoto ] = useState([]);
    const [ startPhoto, setStartPhoto ] = useState( new Date(prev3days).toLocaleString(References.locale) );
    const [ finishPhoto, setFinishPhoto ] = useState( new Date(now).toLocaleString(References.locale) );

    const [ settings, setSettings ] = useState({});
    const [ isShowSettings, setIsShowSettings ] = useState( false );    
    const [ isShowedSettings, setIsShowedSettings ] = useState( false );

    const [ isShowAnalytic, setIsShowAnalytic ] = useState( false );

    const [ windowSize, setWindowSize ] = useState({
        'width': 500,
        'height': document.documentElement.clientHeight * 0.9
    });

    const [ isShowExportData, setIsShowExportData ] = useState( false );
    const [ isMchsDropDownOpened, setIsMchsDropDownOpened] = useState( false );

    const [ normalizeMethod, setNormalizeMethod ] = useState(null);

    const [ isShowHelpContext, setIsShowHelpContext ] = useState(false);
    const [ isShowWaterlevelHelpContext, setIsShowWaterlevelHelpContext ] = useState(false);
    const [ isShowAnalyticHelpContext, setIsShowAnalyticHelpContext ] = useState(false);
    const [ isShowEventHelpContext, setIsShowEventHelpContext ] = useState(false);
    const [ isShowWindroseHelpContext, setIsShowWindroseHelpContext ] = useState(false);
    const [ isShowForecastAggHelpContext, setIsShowForecastAggHelpContext] = useState(false)

    const [ startPhotoInGallery, setStartPhotoInGallery ] = useState( 0 );
    const [ isShowPhotoGallery, setIsShowPhotoGallery ] = useState( false );

    const {permission, userSettings} = useAuth();

    const lineChartData = useMemo(() => ({
        labels: prepared ? (chartData.length > 1 ? chartData[0].labels : chartData.labels) : [],
        datasets: !prepared
            ? []
            : chartData.length > 1
                ? getGroupChartData(chartData, measurersHiddenInGroup)
                : getChartDatasets(chartData, measurer, measurerBasis)
    }), [prepared, chartData, measurersHiddenInGroup, measurer, measurerBasis]);

    const lineChartOptions = useMemo(() => {
        if (!prepared || !measurer?.type)
            return {};

        const options = setLineChartOptions(measurer, chartData, measurerBasis, userSettings);
        const hasAnnotations = Object.keys(options.plugins.annotation.annotations || {}).length > 0;
        const zoomMode = hasAnnotations ? 'x' : 'xy';
        const labels = Array.isArray(chartData) ? chartData[0]?.labels : chartData.labels;
        const xMinRange = Math.max(1, ((labels?.length || 1) - 1) / 10);
        const yRange = options.scales.y.max - options.scales.y.min;
        options.plugins.zoom = {
            limits: {
                x: { min: 'original', max: 'original', minRange: xMinRange },
                y: {
                    min: 'original',
                    max: 'original',
                    minRange: Number.isFinite(yRange) && yRange > 0 ? yRange / 10 : undefined
                }
            },
            zoom: {
                drag: {
                    enabled: true,
                    threshold: 8,
                    backgroundColor: 'rgba(24, 144, 255, 0.2)',
                    borderColor: 'rgba(24, 144, 255, 0.8)',
                    borderWidth: 1
                },
                wheel: { enabled: true },
                pinch: { enabled: true },
                mode: zoomMode,
                onZoomComplete: () => {
                    if (isResettingLineChartZoom.current)
                        return;
                    setIsLineChartZoomed(true);
                    setAutoUpdateEnabled(false);
                }
            },
            pan: {
                enabled: false
            }
        };
        return options;
    }, [prepared, measurer, chartData, measurerBasis, userSettings]);

    const onResetLineChartZoom = () => {
        isResettingLineChartZoom.current = true;
        isResettingBarChartZoom.current = true;
        lineChartRef.current?.resetZoom();
        barChartRef.current?.resetZoom();
        isResettingLineChartZoom.current = false;
        isResettingBarChartZoom.current = false;
        setIsLineChartZoomed(false);
        setIsBarChartZoomed(false);
    };

    const syncFooterMeasurer = (source) => {
        if (!source) return;
        setFooterMeasurer({
            ...source,
            extInfo: formatMchExtInfo(source?.mchs || stationInfo?.mchs, source.type, userSettings)
        });
    };

    //обработка слоя актуальности для замены последних измерений
    useEffect(() => {
        if (stationInfo.mchs && measurer.uuid) {
            
            const actualMch = findInJSONArray(stationInfo?.mchs, 'uuid', measurer.uuid);
            if (actualMch) {
                syncFooterMeasurer(actualMch);
            }
        }
    }, [stationInfo, measurer]);


    useEffect(() => {
        if (!loaded) {
            const isOpenByGroup = stationInfo?.mchs_groups?.hasOwnProperty(mchs);
            const isOpenByPhoto = stationInfo?.photo?.uuid === mchs;

            //если открываем окно из фото, то загружаем первый измерительный канал из списка
            if (isOpenByPhoto)
                mchs = stationInfo?.mchs[0].uuid;

            let currMch = null;            
            if (isOpenByGroup) {
                currMch = FindFirstMchInGroup(stationInfo.mchs, mchs);
                initByGroup(currMch)
            } else {
                currMch = resolveMchForChart(findInJSONArray(stationInfo.mchs, 'uuid', mchs));
                initByMch(currMch);
            }
            setMeasurer( currMch );            
            setMeasurerBasis(GetFirstValueOfBasis(currMch.type))
        }

    }, []);

    useEffect(() => {
        if (prepared) {
            setChartData(prepareMeasurers(data, measurer.uuid, type, measurer.type, chartType, chartSettings, settings, measurerBasis, userSettings))             
        }
    }, [userSettings.setting_pressure_unit]) 

    useEffect(() => {        
        if (prepared) {            
            setMeasurer(prev => ({
                ...prev,
                extInfo: formatMchExtInfo(measurer.mchs, measurer.type, userSettings)
            }))
        }
    }, [userSettings.setting_wind_unit])

    const initByGroup = (mch) => {
        setAutoUpdateEnabled(true);
        onMchsGroupLoading(station.station, mch);
    }

    const initByMch = (mch) => {
        const basis = GetFirstValueOfBasis(mch.type);
        setAutoUpdateEnabled(true);
        setSettings(mch.settings);
        setIsShowSettings(mch.settings != null);
        setIsShowAnalytic( References.mchs[mch.type]?.analytic )
        setMeasurerBasis(basis);

        loadMeasurers(mch.uuid, type, mch.type, start, finish, null, normalizeMethod)
        .then((data) => {
            const chartType = getChartType( mch.chartType )
                            
            setData(data)
            setChartData(prepareMeasurers(data, mch.uuid, type, mch.type, chartType, null, mch.settings, basis, userSettings) );
            setChartType( chartType ); 
            if (station.tab)
                onTabChange( station.tab );

            setLoaded(true);
            setPrepared(true);
        });   

    }

    const ShowSettings = (  ) => {
        let hasSettings = 0;
        let result = null;

        if (References.mchs[measurer.type].hasOwnProperty('settings')) {

            const isHasBasisSettings = measurerBasis && hasNestedProperty(References.mchs[measurer.type]?.basis, measurerBasis);            
            const mchSettings = isHasBasisSettings ? getNestedProperty(settings, measurerBasis) : settings;
            result = (Object.keys(References.mchs[measurer.type].settings).map((val) => {
                
                if (mchSettings[val]) {                    
                    ++hasSettings;

                    const settingInfo = References.mchs[measurer.type].settings[val];
                    const unit = settingInfo?.unit ? settingInfo.unit : GetMeasurerUnitByBasis(measurerBasis, measurer, val);
                    const prec = settingInfo?.prec ? settingInfo.prec : References.mchs[measurer.type].precision;

                    return (
                        <div className="d-flex jc-space-between" key={"settings" + measurer.uuid + val}>
                            <div className="mr-2">{References.mchs[measurer.type].settings[val].name}</div>
                            <div className="ml-2 b">{round(mchSettings[val], prec)} {unit}</div>
                        </div>
                    );
                }
            }));
        }
        if (!hasSettings)
            result = <div>{References.dictionary.no_canal_settings}</div>;
        return result;
    }

    const onNormalizeChange = ( value ) => {
        setNormalizeMethod(  value );
        setExpired( true );
    } 

    const onChangeBasis = (value, item) => {
        setMeasurerBasis(value)
        setChartData(prepareMeasurers(
            data, 
            measurer.uuid, 
            type, 
            measurer.type, 
            chartType, 
            chartSettings, 
            settings,
            value,
            userSettings                    
        ));

    }

    const onMeasurerSettingsClick = (e) => {
        let currisShowedSettings = isShowedSettings;
        setIsShowedSettings( !currisShowedSettings );
        e.stopPropagation();

        window.addEventListener("click", onMeasurerSettingsClose);
    }    

    const onMeasurerSettingsClose = () => {
        window.removeEventListener("click", onMeasurerSettingsClose);        
        setIsShowedSettings( false );
    }

    const onMeasurerExportDataClick = () => {
        let currIsShowedExportData = isShowExportData;
        setIsShowExportData( !currIsShowedExportData );
    }

    const onChartKindChange = ( e ) => {
        const kind = e.target.value;
        setChartKind( kind );
    }

    const handlerClose = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose(station.index);
    }

    const onStartOk = ( value ) => {
        setStart( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))
        setExpired( true );
    }

    const onFinishOk = ( value ) => {
        setFinish( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))
        setExpired( true );        
    }

    const onStartPhotoOk = ( value ) => {
        setStartPhoto( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))
        setExpiredPhoto( true );
    }

    const onFinishPhotoOk = ( value ) => {
        setFinishPhoto( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))
        setExpiredPhoto( true );        
    }

    const onMchLoading = (newStart = start, newFinish = finish) => {
        const safeRange = normalizeChartRange(newStart, newFinish, start, finish);

        onResetLineChartZoom();
        setLoaded(false);
        loadMeasurers( measurer.uuid, type, measurer.type, safeRange.start, safeRange.finish, chartSettings, normalizeMethod )
            .then((data) => {
                const chartType = chartForciblyType ? chartForciblyType : getChartType( measurer.chartType );
                const preparedData = prepareMeasurers(
                    data,
                    measurer.uuid,
                    type,
                    measurer.type,
                    chartType,
                    chartSettings,
                    settings,
                    measurerBasis,
                    userSettings
                );
                setStart(safeRange.start);
                setFinish(safeRange.finish);
                setChartType( chartType );
                setData(data);
                setChartData(preparedData);
                setLoaded(true);
                setExpired( false );
        });
    }

    const onShowChartClick = () => {
        if (isChartGrouped)
            onMchsGroupLoading(station.station, measurer);
        else
            onMchLoading(start, finish);
    }

    // Auto-refresh: use base constants `now` and `prev` as the period origin and shift them by 5s each tick
    useEffect(() => {
        const baseNowMs = new Date(now).getTime();
        const basePrevMs = new Date(prev).getTime();
        let offset = 0;

        const tick = () => {
            try {
                if (!autoUpdateEnabled)                    
                    return 
                
                offset += AUTO_REFRESH_CHART_MS;
                const newStartTs = basePrevMs + offset;
                const newFinishTs = baseNowMs + offset;
                const newStart = new Date(newStartTs).toLocaleString(References.locale);
                const newFinish = new Date(newFinishTs).toLocaleString(References.locale);

                if (isChartGrouped)
                    onMchsGroupLoading(station.station, measurer, newStart, newFinish);
                else
                    onMchLoading(newStart, newFinish);
            } catch (e) {
                console.error('auto-refresh tick error', e);
            }
        };
        let id = null;
        //autoenabled сбрасывается пи смене пользователем дат, уничтожаем таймер
        if (autoUpdateEnabled)
            id = setInterval(tick, AUTO_REFRESH_CHART_MS)
        else 
            clearInterval(id);
        return () => clearInterval(id);
    }, [measurer?.uuid, autoUpdateEnabled]);
    
    const setBarChartOptions = () => {
        let chartOptions = chartBarOptions();

        //устанавливаем min-max для оси y
        chartOptions.scales.y.min = setChartMin(chartData, measurer);
        chartOptions.scales.y.max = setChartMax(chartData, measurer);

        const xMinRange = Math.max(1, ((chartData.labels?.length || 1) - 1) / 10);
        const yRange = chartOptions.scales.y.max - chartOptions.scales.y.min;
        chartOptions.plugins.zoom = {
            limits: {
                x: { min: 'original', max: 'original', minRange: xMinRange },
                y: {
                    min: 'original',
                    max: 'original',
                    minRange: Number.isFinite(yRange) && yRange > 0 ? yRange / 10 : undefined
                }
            },
            zoom: {
                drag: {
                    enabled: true,
                    threshold: 8,
                    backgroundColor: 'rgba(24, 144, 255, 0.2)',
                    borderColor: 'rgba(24, 144, 255, 0.8)',
                    borderWidth: 1
                },
                wheel: { enabled: true },
                pinch: { enabled: true },
                mode: 'xy',
                onZoomComplete: () => {
                    if (isResettingBarChartZoom.current)
                        return;
                    setIsBarChartZoomed(true);
                    setAutoUpdateEnabled(false);
                }
            },
            pan: {
                enabled: false
            }
        };

        //дополняем тултипы
        if (measurer.tooltips) {
            switch (measurer.type) {
                case 'precipitationduo':
                case 'precipitation':                
                    chartOptions.plugins.tooltip.callbacks = {
                        footer: function( item ) {  
                            if (item.length > 0) {                                                                 
                                let field = References.mchs[measurer.type].bar_colors.field;
                                let dataIndex = item[0].dataIndex;     

                                let precipitationType = chartData.source[dataIndex][field];
                                let precipitationValue = chartData.data[dataIndex];

                                if (precipitationValue > 0 && measurer.tooltips.hasOwnProperty(precipitationType))                                
                                    return measurer.tooltips[precipitationType];
                            }
                        }
                    }
                break;
            }
        }

        return chartOptions;

    }

    const precipitaionIcons = ( field ) => {
        let values      = [];
        let pics        = [];

        for ( let i in chartData.source ) {
            let me = chartData.source[i];
            let pic = new Image(25, 25);
            if ( chartData.data[i] > 0 && me.hasOwnProperty( field ) && forecastPics.hasOwnProperty(me[field]) ) {
                pic.src = 'data:image/svg+xml;utf8,' + forecastPics[me[field]];
            }
            pics.push(pic);
            values.push(chartData.data[i] + 0.2);
        }

        return {
            type: 'line',
            data: values,
            label: null,
            backgroundColor: "rgba(255, 255, 255, 1)",
            borderColor: "rgba(255, 255, 255, 1)",
            borderWidth: 0,
            hideTooltip: true,
            pointStyle: pics
        }
    }

    const chartPointIcons = ( params ) => {
        let icons = [];
        switch (params.function) {
            case 'precipitaionIcons':
                icons = precipitaionIcons( params.field );
                break;
        }
        return icons;
    }

    const chartDataIcons = () => {
        if (References.mchs[measurer.type].hasOwnProperty('point_icons')) {
            if (typeof References.mchs[measurer.type].point_icons != 'undefined') {
                return chartPointIcons(References.mchs[measurer.type].point_icons);
            }
        }
    }

    const chartDataBarColors = () => {
        let def =  "#00a";
        if (!References.mchs[measurer.type].hasOwnProperty('bar_colors')) 
            return def;

        let result = [];

        let me = References.mchs[measurer.type].bar_colors;
        let colors = me.colors;
        let field = me.field;
        let func = me.function;

        switch (func) {
            case 'precipitationColor':
                for (let i in chartData.source) {                    
                    let type = chartData.source[ i ][ field ];
                    if (colors.hasOwnProperty(type))
                        result.push( colors[type]);
                    else
                        result.push( def );
                }
                break;

            default:
                result.push( def );
            break;                
        }
        return result;            

    }

    const onMchsGroupLoading = (station, mch, nextStart = start, nextFinish = finish) => {
        const safeRange = normalizeChartRange(nextStart, nextFinish, start, finish);
        onResetLineChartZoom();
        setIsLineChartZoomed(false);

        const groupMeasurer = {
            ...CorrrectGroupToMch(mch),
            typeName: mch.group_name || mch.typeName
        };
        const basis = GetFirstValueOfBasis(groupMeasurer.type);

        setAutoUpdateEnabled(true);
        setIsMchsDropDownOpened(false);        
        setLoaded( false );
        setIsChartgrouped(true);                
        setChartSettings({});  
        setMeasurer(groupMeasurer);
        setSettings(groupMeasurer.settings);
        setMeasurerBasis(basis);
        setIsShowSettings(groupMeasurer.settings != null);
        setIsShowAnalytic(References.mchs[groupMeasurer.type]?.analytic);
        /*if (resetGroup)
            setMeasurersHiddenInGroup([]);*/

        loadGroupMeasurers(station, groupMeasurer.group_id, safeRange.start, safeRange.finish )
        .then(data => {
            setStart(safeRange.start);
            setFinish(safeRange.finish);
            setIsShowedSettings( false );  
            setIsShowSettings(false);

            setData(data)
            setChartData(prepareGroupMeasurers(data, groupMeasurer.type, groupMeasurer.settings, basis, userSettings));            
            setMeasurerGroups(SetMchGroups(station?.mchs, groupMeasurer.group_id));
        })
        .finally(_ => {
            setLoaded(true);
            setExpired( false );
            setPrepared(true);
        });        
    }

    const onMchsDropDownGroupChartClick = ( station, mch ) => {
        onMchsGroupLoading(station, mch, start, finish);
    }

    const onMchsDropDownClick = ( mchs ) => {
        const selectedMch = resolveMchForChart(mchs);

        onResetLineChartZoom();
        setAutoUpdateEnabled(true);
        setIsChartgrouped(false);        
        setIsMchsDropDownOpened(false);
        setLoaded( false );
        setChartSettings({}); 
        setMeasurersHiddenInGroup([]);                

        loadMeasurers(selectedMch.uuid, type, selectedMch.type, start, finish)
            .then((data) => {
                const basis = GetFirstValueOfBasis(selectedMch.type);
                setData(data)                    
                setChartData(prepareMeasurers(data, selectedMch.uuid, type, selectedMch.type, chartType, null, selectedMch.settings, basis, userSettings));

                setMeasurer(selectedMch);
                syncFooterMeasurer(selectedMch);
                setMeasurerBasis(basis)
                setIsShowedSettings( false );       
                setSettings(selectedMch.settings);
                setIsShowSettings(selectedMch.settings != null);
                setChartForciblyType(null);
                setChartType(getChartType(selectedMch.chartType));

                const isHasAnalytic = References.mchs[selectedMch.type]?.analytic;
                setIsShowAnalytic( isHasAnalytic );                
                if (!isHasAnalytic)
                    setChartKind('chart');
        
                setLoaded( true );
            });
    };

    const onMchsDropDownOpenChange = (nextOpen) => {
        setIsMchsDropDownOpened(nextOpen);
        //если есть вкладка прогноз, то там тоже надо сбросить активную вкладку
        setForecastTab('summary_tab')

    }

    const onPhotoClick = () => {
        showPhotos();
    }

    const onPhotoLoad = (photoId, src) => {
        const index = findIndexInJSONArray(photos, 'id', photoId)
        if (index > -1) {
            const currPhotos = photos;
            currPhotos[index]['src'] = src;
            setPhotos([...currPhotos]);
        }
    }

    const onOpenPhotoGallery = ( idx ) => {
        setStartPhotoInGallery(idx)
        setIsShowPhotoGallery(true)
    }

    const onTabChange = ( key ) => {
        setActiveTab( key );
        if ( key == 'photo') {
            if (typeof stationInfo.photo != 'undefined')
                showPhotos( stationInfo, startPhoto, finishPhoto );
        }
    }

    const onTabChartTypeChange = ( key ) => {
        setChartType( key );
        setChartForciblyType( key );
    }

    const onTabChartChange = ( key ) => {
        setChartTabActive(key);
    }

    const onResizeStart = ( event ) => {
        setIsChartRedraw(false);
    }

    const onResize = (_, props) => {
        setWindowSize({
            "width": props.size.width,
            "height": props.size.height
        });
    }

    const onResizeStop = () => {
        setIsChartRedraw( true );
    }

    const onMchItemGroupVisibleChange = ( idx, state ) => {
        if (!state) {
            setMeasurersHiddenInGroup(prev => [...prev, idx]);
        } else {
            setMeasurersHiddenInGroup(prev => prev.filter(val => val !== idx));
        }
    }

    const onCloseHelpContext = () => {
        setIsShowHelpContext(false);
    }

    const onCloseAnalyticHelpContext = () => {
        setIsShowAnalyticHelpContext(false)
    }

    const onShowAnalyticHelpContext = () => {
        setIsShowAnalyticHelpContext(true);
    }

    const onCloseEventHelpContext = () => {
        setIsShowEventHelpContext(false);
    }

    const onShowEventHelpContext = () => {
        setIsShowEventHelpContext(true);
    }

    const onCloseWindroseHelpContext = () => {
        setIsShowWindroseHelpContext(false);
    }

    const onShowWindroseHelpContext = () => {
        setIsShowWindroseHelpContext(true);
    }

    const onShowWaterlevelHelpContext = () => {
        setIsShowWaterlevelHelpContext(true)
    }

    const onCloseWaterlevelHelpContext = () => {
        setIsShowWaterlevelHelpContext(false)
    }

    const onCloseForecastAggHelpContext = () => {
        setIsShowForecastAggHelpContext(false);
    }

    const onShowForecastAggHelpContext = () => {
        setIsShowForecastAggHelpContext(true);
    }

    const showPhotos = () => {
        setActiveTab('photo')        
        setLoadedPhoto( false );
        loadPhotos( stationInfo.photo, startPhoto, finishPhoto )
        .then((data) => {
            let result = parsePhotos(data);
            setPhotos( result );
            setLastPhoto( result.length > 0 ? result[result.length - 1] : []);
            setLoadedPhoto( true );
            setExpiredPhoto( false );
        });
    }
    
    const setPrecipitationAggregation = ( key, value ) => {
        var settings = chartSettings;        

        if (key === 'period' && value.length === 0) {
            settings = {
                period: "",
                rolling: "",
                precipitation_type: "",
                alt_field: ""
            }
        }
        else { 
            settings[key] = value;
            if (key === 'period' && !settings?.rolling)
                settings.rolling = "1";                
            settings.alt_field = References.mchs.precipitation.aggregate_field;                        
        }

        setChartSettings(prevData => ({...prevData, 
            period: settings.period,
            rolling: settings.rolling,
            precipitation_type: settings.precipitation_type,
            alt_field: settings.alt_field
        }) );
        setExpired( true );        
    }
            
    const mchsDropdownRender = (station, mchs, measurer, height) => {
        return <MchsDropdown 
            station={station}
            mchs={mchs}
            group={measurer?.group_id} 
            selectedGroupId={isChartGrouped ? measurer?.group_id : null}
            selectedGroupName={isChartGrouped ? measurer?.group_name : null}
            height={height}
            onClickHandle={onMchsDropDownClick} 
            onGroupChartClickHandle={onMchsDropDownGroupChartClick}
        />
    }
const renderForecastFooter = () => {
    console.log(forecastTab)
    const lastValue = measurer.mchs?.state?.last_value;

    if (forecastTab === 'summary_tab')
        return null;

    if (forecastTab === 'waterlevel_tab') {
        const waterlevel = lastValue?.waterlevel;

        return (
            <div className="text-left">
                Последнее измерение:
                <span className="b ml-1">
                    {waterlevel?.bs
                        ? round(
                            waterlevel.bs,
                            References.mchs.waterlevel.precision
                        )
                        : '---'
                    }
                </span>
                &nbsp;
                {References.mchs.waterlevel.unit}
                <span className="b ml-2">
                    {waterlevel?.time
                        ? ShowLocaleDateTime(new Date(waterlevel.time))
                        : '---'
                    }
                </span>
            </div>
        );
    }

    if (forecastTab === 'calc_tab') {
        const forecast = lastValue?.forecastwaterlevel;

        return (
            <div className="text-left">
                Последний прогноз:
                <span className="b ml-1">
                    {getDangerShortName(forecast?.danger_level)}
                </span>
                <span className="b ml-2">
                    {forecast?.time
                        ? ShowLocaleDateTime(new Date(forecast.time))
                        : '---'
                    }
                </span>
            </div>
        );
    }

    return null;
};

const footerSource = footerMeasurer?.uuid ? footerMeasurer : measurer;
                
    return (
        <>

        {isShowHelpContext && 
        <ChartWindowHelpContext 
            onClose={onCloseHelpContext}
        />
        }

        {isShowWaterlevelHelpContext &&
            <WaterlevelHelpContext 
                onClose={onCloseWaterlevelHelpContext}
            />
        }

        {isShowAnalyticHelpContext && 
        <AnalyticHelpContext
            onClose={onCloseAnalyticHelpContext}
        />
        }

        {isShowEventHelpContext && 
            <EventHelpContext
                onClose={onCloseEventHelpContext}
            />
        }

        {isShowWindroseHelpContext &&
            <WindroseHelpContext 
                onClose={onCloseWindroseHelpContext}
            />
        }

        {isShowForecastAggHelpContext &&
            <ForecastAggHelpContext 
                onClose={onCloseForecastAggHelpContext}
        />
        }

        {isShowPhotoGallery &&
            <PhotoGallery 
                images={photos} 
                startIndex={startPhotoInGallery} 
                mch={stationInfo.photo.uuid} 
                onClose={() => setIsShowPhotoGallery(false)}
            />
        }

        <Draggable 
            cancel={".no-draggable, .react-resizable-handle"}
            bounds={{
                left: windowSize.width * DRAGGABLE_BOUNDS_PERCENT - windowSize.width,
                right: document.documentElement.clientWidth -  windowSize.width * DRAGGABLE_BOUNDS_PERCENT,
                top: windowSize.height * DRAGGABLE_BOUNDS_PERCENT - windowSize.height,
                bottom: document.documentElement.clientHeight - windowSize.height * DRAGGABLE_BOUNDS_PERCENT
            }}
        >
        <Resizable height={windowSize.height} width={windowSize.width} onResizeStart={onResizeStart} onResize={onResize} onResizeStop={onResizeStop}>
        <div className="chart-window" style={{"left": 10 * station.index, "top": 10 * station.index, "width": windowSize.width, "height": windowSize.height}}>
            <button type="button" className="close no-draggable" onClick={handlerClose} aria-label="Закрыть окно">&times;</button>
            <span className="chart-window-help-icon help-icon no-draggable" onClick={() => {setIsShowHelpContext(true)}}><QuestionCircleOutlined /></span>
            <div className="b p-1 text-left chart-window-title flex-shrink-0" level_code={stationInfo.state.level_code}>
                {stationInfo.name}
            </div>

            <Tabs
                className="ph-1 pt-1 no-draggable flex-shrink-0"
                defaultActiveKey={station.tab}
                type="card"
                tabBarStyle={{
                    marginBottom: "0px"
                }}
                onChange={onTabChange}
                items={
                    References.tabsChannels.map((val) => {  
                        if ( val.type !== 'photo' || station?.station?.photo?.uuid) 
                            return {
                                label: val.name,
                                key: val.type
                            }
                    })
                }
                />
            <div className={activeTab !==  'mchs' ? 'd-none' : 'flex-grow-1'} style={{overflowY: "hidden"}}>
                <div className="measurers-wrap">   
                    {!loaded &&
                    <div className="loading loading-wrapper"></div>
                    }

                    {prepared &&
                    <>
                    <div className={`white p-1 bordert-555 flex-shrink-0 pos-relative${isShowAnalytic || permission?.permissions?.can_view_tech_data ? ' has-analytic-switch' : ''}`} level_code={measurer.level_code === null ? References.no_data_code : measurer.level_code}>
                        <div className="text-uppercase b">
                            <Dropdown
                                key="analytic_tab"
                                onOpenChange={onMchsDropDownOpenChange}
                                open={isMchsDropDownOpened}
                                trigger={['click']}
                                dropdownRender={() => mchsDropdownRender(stationInfo, stationInfo.mchs, measurer, windowSize.height)}
                            >
                                <a onClick={(e) => e.preventDefault()} className="w-100-child cursor-pointer no-draggable">
                                    <Space>
                                        {isChartGrouped && measurer?.group_name ? measurer.group_name : measurer.typeName}
                                        <DownOutlined />
                                    </Space>
                                </a>                                
                            </Dropdown>

                                <div key="chart_analytic_wrapper" className="chart_analytic_wrapper">
                                    <AnalyticChartChange isHasAnalytic={isShowAnalytic} chartKind={chartKind} onChartKindChange={onChartKindChange}/>
                                </div>                                    

                        </div>
                    </div>

                    {chartKind === 'chart' ? (
                    <>
                    <Row className="bg-color-eee borderb-555 flex-shrink-0">
                        <Col span="24">
                            <div className="p-1 d-flex jc-space-between pos-relative">
                                <div style={{maxWidth: 380}}>
                                    <Space>
                                        <CustomDatepicker isCustom={false} start={start} finish={finish} onStart={onStartOk} onFinish={onFinishOk} onUserInteraction={() => setAutoUpdateEnabled(false)}/>                                    
                                        <Button type="default" shape="circle" icon={<ReloadOutlined />} onClick={onShowChartClick} className="no-draggable"/>                                                                        
                                    </Space>
                                </div>
                                <div className="chart-toolbar-actions">
                                    <div className="text-nowrap">
                                        <div className="chart-toolbar-buttons">
                                            {!References.mchs[measurer.type].hide_export &&
                                            <Button type="default" shape="circle" icon={<FileExcelOutlined />} onClick={onMeasurerExportDataClick} className={"d-inline-block no-draggable ml-2"}/>                                                                                                    
                                            }
                                            <ComparisonChannelButton
                                                channel={measurer}
                                                station={stationInfo}
                                                start={start}
                                                finish={finish}
                                                chartSettings={chartSettings}
                                                isChart={chartKind === 'chart' && !isChartGrouped}
                                            />
                                            <Button type="default" shape="circle" icon={<InfoCircleOutlined />} onClick={onMeasurerSettingsClick} className={"no-draggable" + (!isShowSettings ? " d-none" : " ml-1 d-inline-block")}/>                                                                    
                                        </div>
                                    </div>
                                </div>
                                {isShowedSettings &&
                                    <div className="measurer-settings-panel no-draggable">
                                        <div className="measurer-settings-close" onClick={onMeasurerSettingsClose}>×</div>
                                        {ShowSettings()}
                                    </div>
                                }
                            </div>
                        </Col>

                        <Col span={24} className="d-flex p-1">
                        {measurer.type === 'waterlevel' &&
                            <Flex                             
                                align="center" 
                                gap={12}
                                style={{flex: 1, maxWidth: 340, boxSizing: "content-box"}}
                                className="pr-1"
                            >
  
                                <span>{References.dictionary.basis}</span> 
                                <Select 
                                    placeholder={References.dictionary.basis}
                                    style={{flex: 1}}
                                    options={waterlevelBasisOptions(measurer)}
                                    defaultActiveFirstOption={true}
                                    value={measurerBasis}
                                    onSelect={onChangeBasis}
                                />

                            </Flex>
                        }
                        

                        { permission.permissions.can_view_tech_data && References.normalizes_channels.indexOf(measurer.type) !== -1 &&
                            <Select
                                defaultValue={'no'}                                        
                                style={{ width: '100%', flex: 1, maxWidth: 340 }}
                                options={normalizedOptions()}
                                onChange={onNormalizeChange}
                            ></Select>
                        }                                
                        </Col>

                        {measurer.hasOwnProperty('type') && measurer.type.indexOf('precipitation') > -1 &&

                        <>
                        <Col span="24" className="pl-1 pr-1 mb-1">
                            <Row>
                                <Col span="8" className="pr-1">
                                    <Select 
                                        className="no-draggable"
                                        defaultValue=""
                                        value={chartSettings.period}
                                        style={{
                                            width: "100%"
                                        }}
                                        options={[
                                            {value: "", label: "10 минут"},
                                            {value: "1H", label: "1 час"},
                                            {value: "3H", label: "3 часа"}, 
                                            {value: "12H", label: "12 часов"}
                                        ]}
                                        onChange={(value) => setPrecipitationAggregation('period', value)}
                                        placeholder={`Период агрегации`}
                                    />
                                </Col>
                                <Col span="8">                                    
                                    <Select 
                                        className="no-draggable"
                                        defaultValue="1"
                                        value={chartSettings.rolling || "1"}
                                        style={{
                                            width: "100%"
                                        }}
                                        options={[
                                            {value: "1", label: 'Скользящие'},
                                            {value: "0", label: 'Дискретные'}
                                        ]}
                                        onChange={(value) => setPrecipitationAggregation('rolling', value)}
                                        placeholder={`Тип агрегации`}
                                        disabled={!chartSettings?.period}                                        
                                    />
                                </Col>
                                <Col span="8" className="pl-1">
                                    <Select 
                                        className="no-draggable"
                                        defaultValue=""
                                        value={chartSettings.precipitation_type}
                                        style={{
                                            width: "100%"
                                        }}
                                        options={[
                                            {value: "", label: "Все осадки"},
                                            {value: "liquid", label: "Жидкие"},
                                            {value: "solid", label: "Твердые"}
                                        ]}
                                        onChange={(value) => setPrecipitationAggregation('precipitation_type', value)}                                        
                                        placeholder={`Тип осадков`}
                                        disabled={!chartSettings?.period}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        </>
                        }                            

                        <Col span="24">
                            {typeof measurer.chartType == 'object' &&                        
                            <Tabs
                                className="ph-1 pt-1 no-draggable"
                                defaultActiveKey={0}
                                type="card"
                                tabBarStyle={{
                                    marginBottom: "0px"
                                }}
                                onChange={onTabChartTypeChange}
                                items={
                                    measurer.chartType.map(val => {
                                        return {
                                            label: objectValue(val),
                                            key: objectKey(val)
                                        }
                                    })
                                }
                                />
                                }


                            {typeof measurer.tabs == 'object' &&                        
                            <Tabs
                                className="ph-1 pt-1 no-draggable"
                                defaultActiveKey={chartTabActive}
                                type="card"
                                tabBarStyle={{
                                    marginBottom: "0px"
                                }}
                                onChange={onTabChartChange}
                                items={
                                    measurer.tabs.map((val, idx) => {
                                        return {
                                            label: val.title,
                                            key: idx
                                        }
                                    })
                                }
                                />
                                }


                        </Col>
                    </Row>

                    <div className={`no-draggable pos-relative chart-detail-window flex-grow-1 ${expired ? 'bg-color-eee' : ''}`} style={{display: "flex", flexDirection: "row", overflowY: "auto"}}>                                
                        <div className="chart-canvas no-draggable">

                            {measurer.type === 'precipitationduo' && 
                            <span className="help-icon-chart" onClick={onShowForecastAggHelpContext}><QuestionCircleOutlined /></span> 
                            }

                            {expired && 
                                <div className="expired-wrapper"></div>
                            }

                            {chartType === 'bar' &&
                            <>
                            {isBarChartZoomed &&
                                <span
                                    className="zoom-icon-chart"
                                    onClick={onResetLineChartZoom}
                                    
                                >
                                    <ZoomOutOutlined />
                                </span>
                            }
                            <Bar
                                ref={barChartRef}
                                data={
                                    {labels: chartData.labels,
                                    datasets: [
                                        {
                                            fill: false,
                                            pointRadius: 0,
                                            backgroundColor: chartDataBarColors(),                                          
                                            borderColor: '#fff',
                                            borderSkipped: 'right',
                                            borderWidth: 1,
                                            spanGaps: false,
                                            barPercentage: 1,
                                            categoryPercentage: 1,                                    
                                            data: chartData.data,

                                        }
                                    ]
                                }}
                                options={setBarChartOptions()}
                                redraw={isChartRedraw}
                            />
                            </>
                            }

                            {chartType === 'polar' &&
                            <div className="polar-chart-canvas">
                                {References.mchs[measurer.type].polar.show_limits &&
                                    <div>
                                        <div className="polar_limits mb-2">
                                        {References.mchs[measurer.type].polar.limits.map((limit, i) => 
                                            <div key={"limit" + i} className="polar_limits_item" style={{borderBottomColor: References.mchs[measurer.type].polar.limits_colors[i]}}>
                                                {limit}
                                            </div>
                                        )}                                                           
                                        <div className="polar_limits_item_unit ml-1">{References.mchs[measurer.type].unit}</div>
                                        </div>
                                    </div>
                                }
                                <div className="text-center flex-grow-1"> 
                                    <span className="help-icon-chart" onClick={onShowWindroseHelpContext}><QuestionCircleOutlined /></span> 
                                    <PolarArea
                                        data={
                                            {labels: References.mchs[measurer.type].polar.polar_labels,
                                            datasets: polarChartPrepareData(chartData.data, chartData.source, References.mchs[measurer.type].polar, References.mchs[measurer.type].unit)
                                        }}
                                        options = {chartPolarOptions}
                                        redraw={isChartRedraw}
                                    />  
                                </div>
                            </div>                  
                            }

                            {chartType === 'chart_tab' &&
                                <ChartTabs 
                                    measurer={measurer}
                                    data={chartData} 
                                    tabs={measurer.tabs} 
                                    tab={chartTabActive} 
                                    isChartRedraw={isChartRedraw}
                                />
                            }

                            {chartType === 'forecast_water_level' &&
                                <ForecastWaterlevel
                                    data={chartData} 
                                    mch={measurer}
                                    start={start}
                                    finish={finish}
                                    onTabChange={setForecastTab}
                                />
                            }

                            {( (chartType == null) || (chartType === 'line')) &&
                            <>
                            {isLineChartZoomed &&
                                <span 
                                    className="zoom-icon-chart" 
                                    onClick={onResetLineChartZoom}
                                    
                                >
                                        <ZoomOutOutlined />
                                </span>                                 
                            }
                            {measurer.type === 'waterlevel' &&
                                <span className="help-icon-chart" onClick={onShowWaterlevelHelpContext}><QuestionCircleOutlined /></span> 
                            }
                            <Line
                                className=""
                                ref={lineChartRef}
                                key={`${measurer.uuid}${isChartGrouped ? `-${measurer.group_id}` : ''}-${measurerBasis || ''}`}
                                data={lineChartData}
                                options={lineChartOptions}
                                redraw={false}
                                />
                            </>
                            }
                        </div>                        

                        {isChartGrouped &&                             
                        <div className="text-center mv-auto ml-2 mr-2">
                            {measurerGroups.map((val, idx) => {
                                return (
                                    <div 
                                        key={`measurer-group-filter-${val.uuid}`}
                                        className="pt-1 b"
                                    >
                                        <Switch 
                                            className={`custom-switch custom-switch-bg-${idx}`}
                                            onClick={(checked, e) => onMchItemGroupVisibleChange(idx, checked, e)}
                                            checkedChildren={val.mch_name} 
                                            unCheckedChildren={val.mch_name} 
                                            defaultChecked
                                        />
                                    </div>
                                )
                            })}
                        </div>    
                        }

                    </div>
                    </>
                    ) : (
                        <>                            
                            <Analytic station={station} measurer={measurer} setLoaded={setLoaded} onHelpContextClick={onShowAnalyticHelpContext}/>
                        </>
                    )}

                    <div className="chart-window-footer bg-color-eee p-1 bordert-555 flex-shrink-0">
                        {!isChartGrouped && measurer.type === 'forecastwaterlevel'
                            ? renderForecastFooter(forecastTab)
                            : !isChartGrouped && (
                                <div className="text-left">
                                    Последнее измерение:
                                    <span className="b ml-1">
                                        {GetMeasurerLastValueByBasis(measurerBasis, footerSource, userSettings)}
                                    </span> 
                                    &nbsp;{GetMeasurerUnitByBasis(measurerBasis, footerSource, null, userSettings)} 
                                    {footerSource?.extInfo &&
                                        <span>&nbsp;({footerSource.extInfo})</span>    
                                    }
                                    <span className="b ml-2">{
                                    ShowLocaleDateTime(new Date(footerSource?.state_time || measurer?.state_time))               
                                    }</span>  
                                </div>
                            )
                        }
                    </div>
                    </>
                    }
                </div>
            </div>

            <div className={activeTab !==  'event' ? 'd-none' : 'flex-grow-1 no-draggable'}>
                <div className="p-1">
                    {activeTab === 'event' &&
                        <Events station={station} container_height={windowSize.height} onHelpContextClick={onShowEventHelpContext}/>
                    }
                </div>
            </div>

            <div className={activeTab !== 'photo' ? 'd-none' : 'flex-grow-1'}>
                <div className="measurers-wrap">
                    {!loadedPhoto &&
                            <div className="loading loading-wrapper"></div>
                    }
                    <div className="p-1 bg-color-eee borderb-555 flex-shrink-0">
                        <Space>
                            <CustomDatepicker isCustom={false} start={startPhoto} finish={finishPhoto} onStart={onStartPhotoOk} onFinish={onFinishPhotoOk} onUserInteraction={() => setAutoUpdateEnabled(false)}/>            
                            <Button type="default" shape="circle" icon={<ReloadOutlined />} onClick={onPhotoClick} className="no-draggable"/>                                    
                        </Space>
                    </div>

                    <div 
                        className={`chart-window-photo-items pos-relative ph-2 mt-2 flex-grow-1 of-y-auto no-draggable ${expiredPhoto ? 'bg-color-eee' : ''}`}
                        style={{height: 1}}
                    >
                        {expired && 
                            <div className="expired-wrapper"></div>
                        }
                        {photos.map( (data, idx) => 
                            <Photos key={"photo-" + data.id} measurerUUID={stationInfo.photo.uuid} photo={data} onLoad={onPhotoLoad} onClick={() => onOpenPhotoGallery(idx)}/>
                        )}
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    {lastPhoto.time &&
                    <div className="mt-1 bg-color-eee p-1 bordert-555 flex-shrink-0">
                            <div className="text-left">
                                Последнее фото: 
                                <span className="b ml-1">{
                                ShowLocaleDateTime(new Date(lastPhoto.time))               
                                }</span>                    
                            </div>
                    </div>
                    }
                </div>

            </div>            

            <div className={activeTab !== 'description' ? 'd-none' : 'flex-grow-1 of-y-auto'}>
                <div className="ph-2">
                    <Row>
                        <Col span="24">
                            <div className="b">
                                <Space>
                                    Координаты
                                    <Button type="default" shape="circle" icon={<CopyOutlined />} onClick={(e) => CopyText(stationInfo.lat +' '+stationInfo.lon)} className="no-draggable"/>
                                </Space>
                            </div>
                            <div className="ml-2">
                                <span className="rem">Широта/долгота</span><span className="ml-2">{stationInfo.lat}&nbsp;&nbsp;&nbsp;{stationInfo.lon}</span>
                            </div>
                        </Col>
                        <Col span="24">
                            <div className="mt-2 b">Положение</div>                                
                            <div className="ml-2 mt-1">
                                {stationInfo.area}
                                {stationInfo.district && `, ${stationInfo.district}`}
                                {stationInfo.city && `, ${stationInfo.city}`}
                                {stationInfo.locality && `, ${stationInfo.locality}`}
                                {stationInfo.monitoring_object && `, ${stationInfo.monitoring_object}`}
                            </div>
                        </Col>                            

                        <Col span="24">
                            <div className="mt-2 b">Закреплен за</div>                                
                            <div className="ml-2 mt-1">
                                {stationInfo.holder_name}
                            </div>
                        </Col>                            

                        
                    </Row>
                </div>
            </div>
        </div>
    </Resizable>
    </Draggable>

    {isShowExportData && 
        <ExportChartData start={start} finish={finish} station={station.station} measurer={measurer} normalizeMethod={normalizeMethod} settings={chartSettings} isGrouped={isChartGrouped} onClose={onMeasurerExportDataClick}/>
    }
    </>
     );
}
